<template>
  <div>
    <div id="header" :style="bgImage">

      <div id="botonesmenu" title="Seleccion de idioma">

        <router-link
          class="botonidioma"
          style="margin-right: 1rem"
          to="/"
          ><i class="fa fa-home"></i>
          <span style="margin-right: .5rem"></span>
          UPVEHU
          </router-link>
        <a
          v-for="l in langs" :key="l.id"
          class="botonidioma mx-1"
          :id="`lang-button-${l.id}`"
          :class="{'selected': langId == l.id }"
          :aria-label="`${l.label}`"
          href="#" @click="selectLanguage(l)"
          >{{ l.label }}</a>
      </div>

      <img
        class="upvlogo"
        alt="Universidad del País Vasco / Euskal Herriko Unibertsitatea"
        src="../assets/logo_upv_escritorio.svg"
      />
      <div class="topline d-none d-sm-block"></div>
      <h1 class="bannertitle horizontalmenu d-none d-sm-block" v-html="msg" />

      <div class="bottomline d-none d-sm-block"></div>
    </div>
    <div class="row">
      <div class="col-12 d-sm-none">
        <div class="whitebox my-0 mb-3">

        {{ $t('titulo') }}
        </div>
      </div>
      <div class="col-12 mt-3">
        <router-link class="btn btn-upvehu-negro mx-2 mb-2 nav-home" :to="{ name: 'Home' }"
          ><i class="fa fa-home"></i> {{ $t('topmenu.inicio') }} </router-link
        >


        <router-link class="btn btn-upvehu-negro mx-2 mb-2 nav-select-queue" :to="{ name: 'SelectQueue' }" v-if="!useSingleQueue"
          > <i class="fa fa-plus"></i> {{ $t('topmenu.pedircita') }}</router-link
        >
        <router-link class="btn btn-upvehu-negro mx-2 mb-2 nav-my-tickets" :to="{ name: 'MyTickets' }"
          > <i class="fa fa-list"></i> {{ $t('topmenu.miscitas') }} </router-link
        >
        <a class="btn btn-upvehu-negro mx-2 mb-2 nav-open-display d-none" @click="abrirDisplay()"
          > <i class="fa fa-tv"></i> {{ $t("topmenu.esmiturno") }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import Session from "@/session/Session.js";

export default {
  name: "Header",
  props: {
    msg: String
  },
  data: () => ({
    Session,
    langId: 1
  }),
  mounted () {
  },
  computed: {
    useSingleQueue () {
      return Session.store.state.useSingleQueue
    },
    langs () {
      return Session.store.state.languages;
    },
    displayURL() {
      let user = Session.getUser();
      return process.env.VUE_APP_DISPLAYURL + user.uuid;
    },
    bgImage() {
      return `background: url(${require('../assets/header_bg.jpg')})`
    }
  },
  methods: {
    async selectLanguage(l) {
      this.langId = l.id
      Session.setLanguage(l);
    },
    abrirDisplay () {
      window.open(this.displayURL);
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#header {
  /*height: 8.25rem; */
  height: 23rem;
  background-size: cover !important;
}

.upvlogo {
  width: 13.5rem;
  max-width: 40%;
  height: auto;
  margin-left: 3rem;
  margin-bottom: 3rem;
}

h1.bannertitle {
  margin-left: 3rem;
  padding: 1rem 1rem;
  width: 45%;
  max-width: 40%;
  min-width: 200px;
  font-size: 140%;

  font-weight: 700;
  color: #37474f;
  margin-block-start: 0px !important;
  margin-block-end: 0px !important;
  text-transform: uppercase;
  background: white;
}

.topline {
  content: " ";
  margin-left: 3rem;
  background: white;
  width: 15rem;
  max-width: 35%;
  height: 20px;
}

.bottomline {
  content: " ";
  margin-left: 4rem;
  background: white;
  width: 18rem;
  max-width: 30%;
  height: 18px;
}

#botonesmenu {
  float: right;
  margin-top: .5rem;
  margin-right: 1rem;
  padding: .5rem;
  background: white;
}

#botonesmenu > .botonidioma {
  color: black;
  text-decoration: none;
  font-size: 75%;
}

.botonidioma.selected {
  padding: .5rem;
  background: black;
  color: white !important;
}

@media only screen and (max-width: 576px) {
  .upvlogo {
    width: 13.5rem;
    max-width: 30%;
    height: auto;
    margin-left: 1rem;
    margin-bottom: 3rem;
  }

  #header {
      background-position: center !important;
      max-height: 30vh;
  }

}
</style>
